import React from 'react'
import EmblaCarousel from './embla/emblaCarousel'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText } from '@prismicio/react'

const Logo = ({ partner }) => {
  return <GatsbyImage image={partner.logo.gatsbyImageData} alt={partner.logo.alt || ''} placeholder='tracedSVG' loading='eager' />
}

const Partners = ({ slice }) => {
  return (
    <div className='bg-white dark:bg-gray-800'>
      <div className={`component-${slice.slice_type} mx-auto py-8 lg:py-20 relative`}>
        {slice.primary.title && (
          <div className='text-lg dark:text-white px-6 text-center'>
            <PrismicRichText field={slice.primary.title.richText} />
          </div>
        )}
        <div className='flex flex-row flex-wrap sm:flex-nowrap justify-center items-center mt-10 gap-3'>
          <EmblaCarousel
            autoScroll={true}
            options={{
              loop: true,
              skipSnaps: false
            }}>
            {slice.items.map((partner, index) => {
              return (
                <div className='relative flex items-center p-3 sm:p-6 lg:px-8 dark:invert dark:grayscale' key={`partner-${index}`}>
                  {partner.link?.url ? (
                    <a
                      className='transform translate ease duration-200 hover:scale-110 grayscale hover:grayscale-0'
                      href={partner.link.url}
                      rel='noopener noreferrer nofollow'
                      target='_blank'
                      tabIndex={-1}
                      aria-label='View company'>
                      <Logo partner={partner} />
                    </a>
                  ) : (
                    <Logo partner={partner} />
                  )}
                </div>
              )
            })}
          </EmblaCarousel>
        </div>
      </div>
    </div>
  )
}

export default Partners
